module.exports = new __parcel__URL__("apply_k_faq_expanded_zh-cn.9cbf9bca.webp").toString();